import { COLORS } from '@btime/constants'
import React from 'react'

import { Text } from '../../../../../components/presentation/Text'
import { useCurrentModal } from '../../../../../components/modals/ModalsContext'
import Panel from '../../../../../components/structure/Panel'

const LogDetails = () => {
  const { data: log } = useCurrentModal()
  const style = { height: 'calc(85vh - 240px)' }

  return (
    <Panel bgColor={COLORS.light1} noShadow noMargin smallPadding>
      <Text>
        <pre style={style}>
          <code>{JSON.stringify(log.data, null, 4)}</code>
        </pre>
      </Text>
    </Panel>
  )
}

export default LogDetails
